import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import SizePanel from '../SizePanel';
import { childSizes } from './clothingSizeConstants';

import styles from './ClothingSizeRefinement.module.scss';
import { AlgoliaFacets } from '@utils/algolia/knownFacetNames';

const facetNameCheck = (facetName: string, group: string) =>
  facetName === AlgoliaFacets.ClothingSizeKids && childSizes.includes(group);

const ClothingSizePanelContainer = ({
  refinementName,
  group,
  items,
  refine,
}: {
  refinementName: string;
  group: string;
  items: Array<RefinementListItem & { group: string }>;
  refine: (value: string) => void;
}) => {
  const shouldDisplayName = facetNameCheck(refinementName, group);

  return (
    <li className={styles.sizePanelContainer}>
      {shouldDisplayName ? (
        <p className={styles.sizePanelContainerTitle}>{group}</p>
      ) : null}
      <ul className={styles.sizes}>
        {items.map((item) => (
          <li key={`${refinementName}-panel-${item.value}`}>
            <SizePanel
              label={item.label}
              handleClick={(e) => {
                e.preventDefault();
                refine(item.value);
              }}
              selected={item.isRefined}
            />
          </li>
        ))}
      </ul>
    </li>
  );
};

export default ClothingSizePanelContainer;
